import RecipePreparation, { RecipePreparationProps } from "./RecipePreparation";

export { RecipePreparation, RecipePreparationProps };

export default RecipePreparation;
